function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    fechaMin: {
      type: String,
      default: '2000-01-01'
    },
    fechaMax: {
      type: String,
      default: function _default() {
        var today = new Date();
        return today.toISOString().substring(0, 10);
      }
    },
    colSize: {
      type: Number,
      default: 4
    },
    disabled: {
      type: Boolean,
      default: false
    },
    start: {
      type: String,
      default: null
    },
    end: {
      type: String,
      default: null
    },
    includeTime: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      menu: false,
      startTime: '00:00',
      endTime: '23:59'
    };
  },
  mounted: function mounted() {
    this.initializeTimes();
  },
  computed: {
    internalValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        this.$emit('input', val);
      }
    },
    formattedDate: function formattedDate() {
      var val = this.internalValue;
      if (Array.isArray(val) && val.length === 2 && val[0] && val[1]) {
        if (this.includeTime) {
          var formatDateTime = function formatDateTime(date, time) {
            if (!date || !time) return '';
            var dateObj = new Date(date);
            if (isNaN(dateObj.getTime())) return '';
            var dateStr = dateObj.toISOString().substring(0, 10);
            return "".concat(dateStr, " ").concat(time);
          };
          var startFormatted = formatDateTime(val[0], this.startTime);
          var endFormatted = formatDateTime(val[1], this.endTime);
          if (startFormatted && endFormatted) {
            return "".concat(startFormatted, " ~ ").concat(endFormatted);
          }
        } else {
          var format = function format(date) {
            if (!date) return '';
            var dateObj = new Date(date);
            if (isNaN(dateObj.getTime())) return '';
            return dateObj.toISOString().substring(0, 10);
          };
          var _startFormatted = format(val[0]);
          var _endFormatted = format(val[1]);
          if (_startFormatted && _endFormatted) {
            return "".concat(_startFormatted, " ~ ").concat(_endFormatted);
          }
        }
      }
      return '';
    },
    hasTimeError: function hasTimeError() {
      if (!this.includeTime || !this.startTime || !this.endTime) return false;
      var val = this.internalValue;
      if (!Array.isArray(val) || val.length !== 2 || !val[0] || !val[1]) return false;
      var sameDay = String(val[0]).slice(0, 10) === String(val[1]).slice(0, 10);
      if (!sameDay) return false;
      var startMinutes = this.timeToMinutes(this.startTime);
      var endMinutes = this.timeToMinutes(this.endTime);
      return endMinutes <= startMinutes;
    }
  },
  watch: {
    start: {
      handler: function handler(newVal) {
        if (newVal && this.includeTime) {
          this.extractTimeFromISO(newVal, 'start');
        }
      },
      immediate: true
    },
    end: {
      handler: function handler(newVal) {
        if (newVal && this.includeTime) {
          this.extractTimeFromISO(newVal, 'end');
        }
      },
      immediate: true
    }
  },
  methods: {
    handleInput: function handleInput(value) {
      if (Array.isArray(value) && value.length === 2) {
        var _value = _slicedToArray(value, 2),
          start = _value[0],
          end = _value[1];
        if (new Date(start) > new Date(end)) {
          this.$emit('input', []);
          this.$emit('update:start', null);
          this.$emit('update:end', null);
          this.$emit('change', []);
          return;
        }
        this.$emit('input', value);
        this.$emit('change', value);
        if (!this.includeTime) {
          this.$emit('update:start', start);
          this.$emit('update:end', end);
        } else if (!this.hasTimeError && this.startTime && this.endTime) {
          this.emitDateTimeRange();
        }
      } else {
        this.$emit('input', value);
      }
    },
    onTimeChange: function onTimeChange() {
      console.log('Time changed:', {
        startTime: this.startTime,
        endTime: this.endTime
      });
      if (this.includeTime) {
        this.emitDateTimeRange();
      }
    },
    confirmSelection: function confirmSelection() {
      if (this.includeTime) {
        if (this.hasTimeError) {
          return;
        }
        this.emitDateTimeRange();
      }
      this.menu = false;
    },
    emitDateTimeRange: function emitDateTimeRange() {
      if (!Array.isArray(this.internalValue) || this.internalValue.length !== 2) return;
      var _this$internalValue = _slicedToArray(this.internalValue, 2),
        startDate = _this$internalValue[0],
        endDate = _this$internalValue[1];
      if (!startDate || !endDate || !this.startTime || !this.endTime) return;
      var startDateTime = "".concat(startDate, "T").concat(this.startTime, ":00");
      var endDateTime = "".concat(endDate, "T").concat(this.endTime, ":00");
      this.$emit('update:start', startDateTime);
      this.$emit('update:end', endDateTime);
      this.$emit('change', [startDateTime, endDateTime]);
    },
    timeToMinutes: function timeToMinutes(timeString) {
      if (!timeString) return 0;
      var _timeString$split$map = timeString.split(':').map(Number),
        _timeString$split$map2 = _slicedToArray(_timeString$split$map, 2),
        hours = _timeString$split$map2[0],
        minutes = _timeString$split$map2[1];
      return hours * 60 + minutes;
    },
    initializeTimes: function initializeTimes() {
      if (this.includeTime) {
        if (this.start) {
          this.extractTimeFromISO(this.start, 'start');
        } else {
          this.startTime = '00:00';
        }
        if (this.end) {
          this.extractTimeFromISO(this.end, 'end');
        } else {
          this.endTime = '23:59';
        }
      }
    },
    extractTimeFromISO: function extractTimeFromISO(isoString, type) {
      if (!isoString) return;
      console.log('extractTimeFromISO:', {
        isoString: isoString,
        type: type
      });
      var timeMatch = isoString.match(/T(\d{2}:\d{2})/);
      if (timeMatch) {
        var time = timeMatch[1];
        console.log('Time extracted:', {
          time: time,
          type: type,
          currentStartTime: this.startTime,
          currentEndTime: this.endTime
        });
        if (type === 'start' && this.startTime !== time) {
          console.log('Updating startTime from', this.startTime, 'to', time);
          this.startTime = time;
        } else if (type === 'end' && this.endTime !== time) {
          console.log('Updating endTime from', this.endTime, 'to', time);
          this.endTime = time;
        }
      } else {
        console.log('No time match found in:', isoString);
      }
    }
  }
};